<script>
export default {
  data: () => ({
    eggStock: [],
  }),
}
</script>

<template>
  <div>

    <b-card class="mb-3">
      <h4 class="text-center"> Stock Balance </h4>

      <api-loader
        method="get"
        url="v1/sales/egg-stock"
        @loaded="eggStock=$event" />

      <table v-if="eggStock" class="table table-bordered table-sm">
        <thead>
          <th class="text-right pr-3" style="width:80px;">Count</th>
          <th class="pl-3">Type</th>
        </thead>
        <tr v-for="stockItem in eggStock" :key="stockItem.type.id">
          <td class="text-right pr-3"> {{stockItem.quantity}} </td>
          <td class="pl-3"> {{stockItem.type.display_name}} </td>
        </tr>
      </table>
    </b-card>

  </div>
</template>



// WEBPACK FOOTER //
// src/sales/components/EggStockBalance.vue